exports.ROLE_REDIRECT_MAP = {
    superadmin: "/books",
    testgenerator_admin: "/books",
    sales_admin: "/salesManagers",
    elp_admin: "/classes",
    default: "/", // Fallback for unknown roles
};

exports.ROLE_MENU_MAP = {
    superadmin: ["Test Generator", "Sales App", "ELP"],
    testgenerator_admin: ["Test Generator"],
    sales_admin: ["Sales App"],
    elp_admin: ["ELP"]
};

exports.SIDEBAR_PAGES = {
    "Test Generator": ["books", "subjects", "schools"],
    "Sales App": ["salesManagers", "schoolsData", "distributors", "salesDailyReport", "salesReport", "leaveRequests"],
    "ELP": ["classes"]
};